import React, { useEffect, useState } from "react";
import "../styles/theme-dark.css";
import "./ChecklistInstalacionManager.css";

const API = "/api";


export default function ChecklistInstalacionManager() {
  const [blocks, setBlocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newBlockName, setNewBlockName] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadBlocks();
  }, []);

  async function loadBlocks() {
    try {
      setLoading(true);
      const res = await fetch(`${API}/checklists`);
      const json = await res.json();
      if (json.ok) {
        setBlocks(json.blocks || []);
      } else {
        console.error("Error cargando blocks:", json.error);
      }
    } catch (err) {
      console.error("Error cargando blocks:", err);
    } finally {
      setLoading(false);
    }
  }

  // ====== BLOQUES ======
  async function createBlock() {
    if (!newBlockName.trim()) return;
    setSaving(true);
    try {
      const res = await fetch(`${API}/checklists/block`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nombre: newBlockName })
      });
      const json = await res.json();
      if (json.ok) {
        setNewBlockName("");
        loadBlocks();
      } else {
        alert("Error creando bloque: " + (json.error || ""));
      }
    } catch (err) {
      console.error("Error creando bloque:", err);
    } finally {
      setSaving(false);
    }
  }

  async function updateBlock(id, patch) {
    setSaving(true);
    try {
      const res = await fetch(`${API}/checklists/block/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(patch)
      });
      const json = await res.json();
      if (!json.ok) {
        alert("Error actualizando bloque: " + (json.error || ""));
      } else {
        loadBlocks();
      }
    } catch (err) {
      console.error("Error update block:", err);
    } finally {
      setSaving(false);
    }
  }

  async function deleteBlock(id) {
    if (!window.confirm("¿Seguro que quieres borrar este bloque y todos sus ítems?")) return;
    setSaving(true);
    try {
      const res = await fetch(`${API}/checklists/block/${id}`, {
        method: "DELETE"
      });
      const json = await res.json();
      if (!json.ok) {
        alert("Error borrando bloque: " + (json.error || ""));
      } else {
        loadBlocks();
      }
    } catch (err) {
      console.error("Error delete block:", err);
    } finally {
      setSaving(false);
    }
  }

  // ====== ITEMS ======
  async function addItem(blockId) {
    const texto = window.prompt("Texto del nuevo check:");
    if (!texto || !texto.trim()) return;
    setSaving(true);
    try {
      const res = await fetch(`${API}/checklists/item`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ blockId, texto })
      });
      const json = await res.json();
      if (!json.ok) {
        alert("Error creando item: " + (json.error || ""));
      } else {
        loadBlocks();
      }
    } catch (err) {
      console.error("Error creando item:", err);
    } finally {
      setSaving(false);
    }
  }

  async function updateItem(id, patch) {
    setSaving(true);
    try {
      const res = await fetch(`${API}checklists/item/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(patch)
      });
      const json = await res.json();
      if (!json.ok) {
        alert("Error actualizando item: " + (json.error || ""));
      } else {
        loadBlocks();
      }
    } catch (err) {
      console.error("Error update item:", err);
    } finally {
      setSaving(false);
    }
  }

  async function deleteItem(id) {
    if (!window.confirm("¿Borrar este check?")) return;
    setSaving(true);
    try {
      const res = await fetch(`${API}/checklists/item/${id}`, {
        method: "DELETE"
      });
      const json = await res.json();
      if (!json.ok) {
        alert("Error borrando item: " + (json.error || ""));
      } else {
        loadBlocks();
      }
    } catch (err) {
      console.error("Error delete item:", err);
    } finally {
      setSaving(false);
    }
  }

  if (loading) {
    return (
      <div className="page-dark" style={{ padding: 40 }}>
        Cargando checklist…
      </div>
    );
  }

  return (
    <div className="page-dark" style={{ padding: 40 }}>
      <h1 style={{ marginBottom: 20 }}>Checklist instalación (por bloques)</h1>

      <div
        style={{
          marginBottom: 20,
          display: "flex",
          gap: 10,
          alignItems: "center"
        }}
      >
        <input
          className="glass-input"
          style={{ maxWidth: 320 }}
          placeholder="Nombre del nuevo bloque (ej. Instalación, Limpieza…)"
          value={newBlockName}
          onChange={(e) => setNewBlockName(e.target.value)}
        />
        <button
          className="glass-btn primary"
          onClick={createBlock}
          disabled={saving || !newBlockName.trim()}
        >
          Añadir bloque
        </button>
      </div>

      {blocks.length === 0 && (
        <div className="glass-box" style={{ padding: 20 }}>
          No hay bloques todavía. Crea el primero arriba.
        </div>
      )}

      <div className="blocks-grid">
        {blocks.map((block) => (
          <div key={block.id} className="block-card glass-box">
            <div className="block-header">
              <input
                className="glass-input block-title-input"
                value={block.nombre}
                onChange={(e) =>
                  updateBlock(block.id, { nombre: e.target.value })
                }
              />

              <div className="block-actions">
                <label className="toggle-label">
                  <input
                    type="checkbox"
                    checked={block.activo}
                    onChange={(e) =>
                      updateBlock(block.id, { activo: e.target.checked })
                    }
                  />
                  Activo
                </label>

                <button
                  className="glass-btn danger small"
                  onClick={() => deleteBlock(block.id)}
                >
                  Borrar bloque
                </button>
              </div>
            </div>

            <div className="block-items">
              {block.items && block.items.length > 0 ? (
                block.items.map((item) => (
                  <div key={item.id} className="item-row">
                    <input
                      type="checkbox"
                      checked={item.activo}
                      onChange={(e) =>
                        updateItem(item.id, { activo: e.target.checked })
                      }
                    />
                    <input
                      className="glass-input item-text-input"
                      value={item.texto}
                      onChange={(e) =>
                        updateItem(item.id, { texto: e.target.value })
                      }
                    />
                    <button
                      className="glass-btn danger small"
                      onClick={() => deleteItem(item.id)}
                    >
                      x
                    </button>
                  </div>
                ))
              ) : (
                <div className="item-empty">
                  No hay checks en este bloque.
                </div>
              )}
            </div>

            <button
              className="glass-btn secondary small"
              onClick={() => addItem(block.id)}
            >
              + Añadir check
            </button>
          </div>
        ))}
      </div>

      {saving && (
        <div style={{ marginTop: 10, opacity: 0.6 }}>Guardando cambios…</div>
      )}
    </div>
  );
}
